export type HtmlPrintPaper = "b5-portrait" | "a4-landscape" | "a4-label-72318";

export interface HtmlPrintPaperDefinition {
  pageSize: string;
  label: string;
  previewClassName: string;
}

const HTML_PRINT_PAPERS: Record<HtmlPrintPaper, HtmlPrintPaperDefinition> = {
  "b5-portrait": {
    pageSize: "182mm 257mm",
    label: "B5・縦",
    previewClassName: "b5-portrait",
  },
  "a4-landscape": {
    pageSize: "297mm 210mm",
    label: "A4・横",
    previewClassName: "a4-landscape",
  },
  "a4-label-72318": {
    pageSize: "210mm 297mm",
    label: "A4・縦（72318）",
    previewClassName: "a4-label-72318",
  },
};

export function htmlPrintPaperDefinition(paper: HtmlPrintPaper): HtmlPrintPaperDefinition {
  return HTML_PRINT_PAPERS[paper];
}

export function htmlPrintPageRule(paper: HtmlPrintPaper): string {
  return `@page { size: ${htmlPrintPaperDefinition(paper).pageSize}; margin: 0; }`;
}
